<template>
  <PreGameModal :progress="progress" :progressTotal="progressTotal">
    <template #content>
      <div class="content">
        <div class="header">
          <div class="title">Apprenons-en plus sur vous</div>
          <div class="subtitle">Veuillez répondre aux questions ci-dessous</div>
        </div>
        <Transition name="fade" mode="out-in">
          <div class="question" :key="step">
            <div class="questionCount">QUESTION {{ step }} / {{ questions.length }}</div>
            <div class="questionText">{{ questions[step - 1].question }}</div>
            <div class="questionOptions">
              <div v-for="(option, index) in questions[step - 1].options" :key="index" class="option"
                :class="{ selected: selectedAnswers[step - 1] === option }" @click="selectAnswer(step - 1, option)">
                <input type="radio" :name="'question' + step" :value="option" :id="'option' + index"
                  :checked="selectedAnswers[step - 1] === option" />
                <label :for="'option' + index">{{ option }}</label>
              </div>
            </div>
          </div>
        </Transition>
        <div class="buttons">
          <Button label="Question précédente" class="btn secondary outline" @click="Previous" v-if="step >= 2" />
          <Button :label="step >= questions.length ? 'Valider et continuer' : 'Question suivante'" class="btn primary"
            @click="Next" :disabled="!selectedAnswers[step - 1]" />
        </div>
      </div>
    </template>
  </PreGameModal>
</template>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  line-height: normal;

  gap: 40px;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    .title {
      font-size: 32px;
      font-weight: 700;
    }

    .subtitle {
      font-size: 18px;
    }
  }

  .question {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    min-height: 250px;

    .questionCount {
      color: #F2CB36;
      font-size: 16px;
      font-weight: 700;
    }

    .questionText {
      font-size: 28px;
      font-weight: 700;
      text-align: center;
    }

    .questionOptions {
      margin-top: 16px;

      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .option {
        // width: 33%;

        display: flex;
        padding: 16px 24px;
        align-items: center;
        gap: 8px;
        flex: 0 0 30%;

        cursor: pointer;

        // apply cursor pointer to all childs
        * {
          cursor: pointer;
        }

        border-radius: 6px;
        border: 2px solid #464646;
        transition: all 0.2s ease;

        &.selected {
          border-color: #F2CB36;
          background-color: #F2CB361A;
        }

        &:hover {
          border-color: #F2CB36;
        }

        input[type='radio'] {
          flex: 0 0 auto;
        }
      }
    }
  }

  .buttons {
    display: flex;
    gap: 16px;

    .btn {
      border: 2px solid #464646 !important;
    }
  }
}
</style>

<script setup lang="ts">
import { ref, onMounted } from 'vue';

import { useCloudClientStore } from "@/stores/cloud-client";

import PreGameModal from './PreGameModal.vue';

import questions from '@/assets/PreGame/questions.json';

const cloudClient = useCloudClientStore();

defineProps({
  progress: {
    type: Number,
    required: true,
  },
  progressTotal: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits([
  'next',
]);

// Start at question number 1
const step = ref(1);

// Store user answers
const selectedAnswers = ref<Array<string>>([]);

// Select an answer for a question
function selectAnswer(questionIndex: number, option: string) {
  selectedAnswers.value[questionIndex] = option;
}

function Next() {
  if (step.value >= questions.length) {
    cloudClient.pushSurvey(selectedAnswers.value);
    localStorage.setItem('selectedAnswers', JSON.stringify(selectedAnswers.value));
    emit("next");
  }
  step.value++;
}

function Previous() {
  if (step.value <= 1) return
  step.value--;
}

onMounted(() => {
  const savedAnswers = localStorage.getItem('selectedAnswers');
  if (savedAnswers) emit("next");
});

</script>